import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./overview.html";
import { FeatureFlags } from '~/modules/feature_flags';
import { getListingPublisher } from '~/modules/helpers/listingHelper';
import { Routes } from '~/modules/routes';
import { WireI18n } from '~/modules/stores/i18nStore';
import { selectExtensionListing } from '~/modules/utilities/listing_utils';
class Overview extends LightningElement {
  constructor(...args) {
    super(...args);
    this.listing = void 0;
    this.i18n = void 0;
  }
  get highlights() {
    return this.forceListing?.highlights?.filter(Boolean);
  }
  get forceListing() {
    return selectExtensionListing(this.listing);
  }
  get pricingPlan() {
    const pricingPlan = this.listing && this.listing.pricing;

    // @ts-expect-error * Automated Type Error Fix
    return pricingPlan;
  }
  get provider() {
    return getListingPublisher(this.listing);
  }
  get publisherName() {
    return this.provider?.name ?? '';
  }
  get hasHighlights() {
    return this.highlights?.length > 0;
  }
  get showPrivateOffer() {
    return FeatureFlags.FF_PRIVATE_OFFERS;
  }
  get privateOfferCtaLabel() {
    return this.i18n.privateOffer.ctaTitle;
  }
  get privateOfferCtaHref() {
    return `/${Routes.PRIVATE_OFFER}?listingId=${this.listing.external_id || this.listing.appExchangeId}`;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Overview, {
  publicProps: {
    listing: {
      config: 0
    }
  },
  wire: {
    i18n: {
      adapter: WireI18n,
      config: function ($cmp) {
        return {};
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Overview, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;